import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Button, Desktop, Heading, Text } from '@miro-site/core';
import React from 'react';
import { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var StickyUseTemplateDesktop = function StickyUseTemplateDesktop(_ref) {
  var metadataId = _ref.metadataId,
      templateActions = _ref.templateActions,
      headline = _ref.headline,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? 'Get started with this template right now.' : _ref$description,
      actionButtonProps = _ref.actionButtonProps;
  var theme = useTheme();
  return /*#__PURE__*/_jsx(Desktop, {
    "data-track-place": "sticky-use-template",
    $mt: 68,
    $styles: {
      position: 'sticky',
      top: 112
    },
    children: /*#__PURE__*/_jsxs(Box, {
      $py: 24,
      $pl: 24,
      $pr: 30,
      $styles: {
        borderColor: theme.templates.colors.secondary20,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: 16,
        background: 'white'
      },
      children: [/*#__PURE__*/_jsx(Heading, {
        $variant: "h3",
        $mb: 8,
        children: headline
      }), /*#__PURE__*/_jsx(Text, {
        $variant: "p2",
        $styles: {
          color: theme.templates.colors.secondary60
        },
        $mb: 48,
        children: description
      }), actionButtonProps ? /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        "data-track-id": "use-template",
        "data-template-id": metadataId,
        $buttonType: "primary",
        $size: "medium",
        $withArrow: true
      }, actionButtonProps), {}, {
        children: actionButtonProps.children || templateActions.USE_TEMPLATE
      })) : null]
    })
  });
};

export default StickyUseTemplateDesktop;